import Box from '@mui/material/Box';
import { IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

interface Props {
    paths: (value: any) => any[];
    permissions: any;
    children: any;
}

const ScrollableTopBar = ({ children }: Props) => {
    return (
        <Box
            sx={{
                overflow: 'hidden',
                width: '55vw', // Fixed width covering 75% of viewport
                position: 'relative',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    px: 6,
                }}
            >
                {/* Left Chevron Button */}
                <IconButton
                    sx={{
                        position: 'absolute',
                        left: 0,
                        zIndex: 10,
                        backgroundColor: 'white',
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                        },
                    }}
                    onClick={() => {
                        const container = document.getElementById('menu-scroll-container');
                        if (container) {
                            container.scrollBy({
                                left: -150, // Adjust the value for scroll distance
                                behavior: 'smooth',
                            });
                        }
                    }}
                >
                    <ChevronLeft />
                </IconButton>

                {/* Scrollable Menu */}
                <Box
                    id='menu-scroll-container'
                    sx={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        gap: 1,
                        overflowX: 'hidden', // Hide scrollbar
                        scrollBehavior: 'smooth',
                        scrollSnapType: 'x mandatory', // Enables snap for horizontal scrolling
                        width: '100%',
                    }}
                >
                    {children}
                </Box>

                {/* Right Chevron Button */}
                <IconButton
                    sx={{
                        position: 'absolute',
                        right: 0,
                        zIndex: 10,
                        backgroundColor: 'white',
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                        },
                    }}
                    onClick={() => {
                        const container = document.getElementById('menu-scroll-container');
                        if (container) {
                            container.scrollBy({
                                left: 150, // Adjust the value for scroll distance
                                behavior: 'smooth',
                            });
                        }
                    }}
                >
                    <ChevronRight />
                </IconButton>
            </Box>
        </Box>
    );
};

export default ScrollableTopBar;
